import { FingerPrinter } from '../models'

export const fingerprintContext: FingerPrinter = (_, options, fingerprint) => {
  const { context } = options

  return context ? fingerprint.concat(context) : fingerprint
}
